import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { RJCommunicationHubStore } from './rj-communication-hub.store.types';

export const useRJCommunicationHubStore = create<RJCommunicationHubStore>()(
  devtools(
    (set, get) => ({
      candidateToStartRjCommFlow: null,
      setCandidateToStartRjCommFlow: (candidate) => set(() => ({ candidateToStartRjCommFlow: candidate })),
      bulkCandidates: [],
      addBulkCandidateId: (candidate) => {
        set((state) =>
          state.bulkCandidates.some((existing) => existing.es_person_id === candidate.es_person_id)
            ? state
            : { bulkCandidates: [...state.bulkCandidates, candidate] },
        );
      },
      addBulkCandidateIds: (candidates) => {
        set((state) => ({
          bulkCandidates: [...state.bulkCandidates, ...candidates].filter(
            (candidate, index, arr) => arr.findIndex((item) => item.es_person_id === candidate.es_person_id) === index,
          ),
        }));
      },
      removeBulkCandidateId: (id) =>
        set((state) => ({ bulkCandidates: state.bulkCandidates.filter((candidate) => candidate.es_person_id !== id) })),
      removeBulkCandidateIds: (esPersonIds) => {
        if (esPersonIds.length === 0) return;
        const idSet = new Set(esPersonIds);
        set((state) => ({
          bulkCandidates: state.bulkCandidates.filter((candidate) => !idSet.has(candidate.es_person_id)),
        }));
      },
      clearBulkCandidateIds: () => set(() => ({ bulkCandidates: [] })),
      isBulkCandidateSelected: (id) => get().bulkCandidates.some((candidate) => candidate.es_person_id === id),
    }),
    { name: 'RJCommunicationHubStore' },
  ),
);
